import React, { Component } from 'react';
import { Button, Table, Divider } from 'semantic-ui-react';
import axios from 'axios'
import { serverIp, toCurrency } from '../../../../config/constants';

import createBrowserHistory from 'history/createBrowserHistory';
import SendToUpdateFabric from './SendToUpdateFabric';
const history = createBrowserHistory({ forceRefresh: true });

class FabricPaymentLog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transactions: [],
        }
    }

    componentDidMount() {
        console.log("cpx1 ======componentDidMount");
        this.getTransactions();
    }


    getTransactions = () => {
        console.log("cpx1 ======getTransactions");

        this.setState({ loading: true })

        axios.post(serverIp + 'stockPayment/getFabricPaymentLog', {
            apiKey: "getLastTransactions",
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    this.setState({ transactions: response.data.fabricPaymentLog });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get transactions:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }
 
    render() {

        const tableRow = this.state.transactions.length > 0
            ? this.state.transactions.map((trans) =>
                <Table.Row>
                    <Table.Cell> {trans.idfabricPayments} </Table.Cell>
                    <Table.Cell> {trans.dateEntered.replace('12:00:00 AM','')} </Table.Cell>
                    <Table.Cell> {trans.systemItemNumber} </Table.Cell>
                    <Table.Cell> {trans.meters} </Table.Cell>
                    <Table.Cell negative>{toCurrency(trans.totalCost)}</Table.Cell>
                    <Table.Cell>{trans.projectId}</Table.Cell>
                    <Table.Cell>{trans.projectName.substring(0, 40)}</Table.Cell>
                    <Table.Cell positive>{toCurrency(trans.accountBalance)}</Table.Cell>
                    <Table.Cell>{trans.paidVia}</Table.Cell>
                    <Table.Cell>{trans.paymentReference}</Table.Cell>
                    <Table.Cell><SendToUpdateFabric 
                                    idfabricPayments={trans.idfabricPayments} 
                                    fabricPayment = {trans}/></Table.Cell>
                </Table.Row>)
            : ''

        return (<div>
            <Divider horizontal>{'RECENT PAYMENTS'}</Divider>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                    <Table.HeaderCell>Id</Table.HeaderCell>
                        <Table.HeaderCell>Date</Table.HeaderCell>
                        <Table.HeaderCell>Item #</Table.HeaderCell>
                        <Table.HeaderCell>Meters</Table.HeaderCell>
                        <Table.HeaderCell>Total Cost</Table.HeaderCell>
                        <Table.HeaderCell>Proj Id</Table.HeaderCell>
                        <Table.HeaderCell>Project</Table.HeaderCell>
                        <Table.HeaderCell>Acc Balance</Table.HeaderCell>
                        <Table.HeaderCell>Paid</Table.HeaderCell>
                        <Table.HeaderCell>Pay Ref</Table.HeaderCell>
                        <Table.HeaderCell>Update</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>

            </Table>
        </div>);
    }
}

export default FabricPaymentLog;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/FabricPaymentLog.js